<template>
  <router-link to="/annunci" class="ic-nav__link">Compra</router-link>
</template>

<script>
// "Compra" → la pagina annunci (/annunci). Router-link semplice: href reale
// (crawler, apertura in nuova scheda) e aria-current sulla pagina stessa.
export default {
  name: 'BuyNavLink',
}
</script>

<style scoped>
.ic-nav__link {
  font-size: 16px;
  font-weight: 500;
  color: var(--ic-ink, #1e1e1e);
  white-space: nowrap;
  padding: 10px 16px;
  border-radius: 999px;
  cursor: pointer;
  transition: background-color 0.18s ease;
}
/* Stesso hover beige delle altre voci; la pill resta accesa sulla pagina annunci. */
.ic-nav__link:hover,
.ic-nav__link.router-link-exact-active { background-color: #f2efe7; }
/* La visibilità responsive è governata dal layout ospite (ImmaginaHeader:
   sotto 1024px il link vive nel drawer mobile). */
</style>
